<template>
  <div class="profile-reply" v-if="isShow">
    <font-awesome-icon
      icon="times"
      class="text-secondary cancel-reply pointer"
      @click="hide"
    />
    <div :class="['wrap_msg_cotainer_send', { 'w-100': msg.messageType == 4 }]">
      <div
        :class="[
          'reply_container',
          msg.messageType == 4 || msg.messageType == 2
            ? 'msg_cotainer_img'
            : 'msg_cotainer'
        ]"
      >
        <ChatBoxReplyProfile :msg="msg" />
        <div class="wrap_img_upload" v-if="msg.messageType == 4">
          <div class="img_upload">
            <div
              class="img_upload-display"
              v-bind:style="{
                backgroundImage: 'url(' + msg.filePath + ')'
              }"
            ></div>
          </div>
        </div>
        <span v-else class="text-nextline" v-html="msg.message"></span>
      </div>
    </div>
  </div>
</template>

<script>
import ChatBoxReplyProfile from "@/components/chat/chatBox/reply/ChatBoxReplyProfile";
export default {
  components: {
    ChatBoxReplyProfile
  },
  data() {
    return {
      isShow: false,
      msg: null
    };
  },
  methods: {
    show(item) {
      this.msg = item;
      this.isShow = true;
    },
    hide() {
      this.msg = null;
      this.isShow = false;
      this.$emit("hide");
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-reply {
  position: relative;
  padding: 10px 15px;
  .cancel-reply {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 100;
  }
  .text-nextline {
    white-space: pre-line;
    a {
      color: #9c9c9c;
      text-decoration: none;
    }
  }
  .reply_container.msg_cotainer .text-nextline {
    margin-left: 35px;
    color: #9c9c9c !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    max-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .msg_cotainer_img {
    margin-top: auto;
    margin-bottom: auto;
    // margin-left: auto;
    padding: 2px 10px;
    position: relative;
    display: flex;
    justify-content: flex-start;
    width: 80%;
    .wrap_img_upload {
      display: flex;
      width: 100%;
      flex-flow: column;
    }
    .img_upload {
      margin-right: auto;
      height: auto;
      max-height: 20rem;
      width: 100%;
      max-width: 30rem;
      .img_upload-display {
        width: 100%;
        padding-bottom: 56.25%;
        background-size: contain;
        background-position: top left;
        background-repeat: no-repeat;
        background-color: inherit !important;
      }
    }
  }
  .reply_container.msg_cotainer_img {
    margin-top: auto;
    margin-bottom: auto;
    border-radius: 4px;
    background-color: #fbfbfb;
    color: #000;
    padding: 0;
    padding-right: 15px;
    position: relative;
    width: 100%;
    min-width: 25%;
    font-size: 14px;
    width: unset;
    justify-content: space-between;
    margin-left: 0;
    .wrap_img_upload {
      width: 35px !important;
      height: 35px !important;
      .img_upload {
        margin-right: 0;
        margin-left: auto;
        height: unset;
        max-height: unset;
        width: unset;
        max-width: unset;
        .img_upload-display {
          width: 35px !important;
          height: 35px !important;
          padding-bottom: unset;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
